import { A11y, EffectCoverflow, Navigation, Pagination, Scrollbar } from 'swiper';
import './preparation-list.scss';

class PreparationList {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-preparationlist'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$preparation = $element;
        this.$preparationSliderWrapper = this.$preparation.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$$preparationSlides = this.$preparation.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.$$preparationSlidesContent = this.$preparation.querySelectorAll('[' + this.settings.initAttr + '="content"]');
        this.$preparationMainContent = this.$preparation.querySelector('[' + this.settings.initAttr + '="main-content"]');
        this.$preparationSliderPagination = null;
        this.$preparationSliderNext = null;
        this.$preparationSliderPrev = null;
        this.$contentWrapper = null;

        this.preparationSliderStepLabel = this.$preparationSliderWrapper.getAttribute('data-preparationlist-step-label');
        this.preparationSliderPrevLabel = this.$preparationSliderWrapper.getAttribute('data-preparationlist-prev-label');
        this.preparationSliderNextLabel = this.$preparationSliderWrapper.getAttribute('data-preparationlist-next-label');
        this.$preparationSlidePlay = this.$preparation.querySelector('[' + this.settings.initAttr + '="play"]');
        this.$preparationSlidePause = this.$preparation.querySelector('[' + this.settings.initAttr + '="pause"]');
        this.$preparationSlideVideo = this.$preparation.querySelector('[' + this.settings.initAttr + '="video"] video');
        this.$preparationSlider = null;
        this.$activeSlide = null;

        this.activeSlideIndex = 0;
        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;
        this.hasSliderImages = false;
        this.videoPlaying = false;
    }

    initialize () {
        if (this.$preparationSliderWrapper.classList.contains('is--image-slider')) {
            this.hasSliderImages = true;
            this.initSliderContent();
        }

        if (this.$$preparationSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                '../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initSlider();
                this.setEvents();

                this.resizeHandler.customFunctions.push(() => {
                    this.orderSwiperButtons();
                });
            });
        }
    }

    positionSliderContent () {
        for (let index = 0; index < this.$$preparationSlidesContent.length; index++) {
            if (this.activeSlideIndex === 0) {
                this.$$preparationSlidesContent[index].style.setProperty('--translateX', 'translateX(0)');
            } else {
                this.$$preparationSlidesContent[index].style.setProperty('--translateX', `translateX(${this.activeSlideIndex * -100}%)`);
            }
        }
    }

    initSliderContent () {
        this.contentWrapper = document.createElement('div');
        this.contentWrapper.classList.add('preparation-list__content-wrapper');

        if (this.$$preparationSlidesContent.length > 0) {
            this.$preparationMainContent.appendChild(this.contentWrapper);
            for (let index = 0; index < this.$$preparationSlidesContent.length; index++) {
                this.contentWrapper.appendChild(this.$$preparationSlidesContent[index]);
            }
            this.positionSliderContent();
        }
    }

    addButtonLabel () {
        this.$preparationSliderNext = this.$preparation.querySelector('[' + this.settings.initAttr + '="next"] i');
        this.$preparationSliderPrev = this.$preparation.querySelector('[' + this.settings.initAttr + '="prev"] i');

        if (this.$preparationSliderNext && this.$preparationSliderPrev) {
            this.$preparationSliderNext.textContent = this.preparationSliderNextLabel;
            this.$preparationSliderPrev.textContent = this.preparationSliderPrevLabel;
        }
    }

    orderSwiperButtons () {
        const $swiperNavigation = this.$preparation.querySelector('.swiper-navigation');
        if ($swiperNavigation) {
            let height;

            if (this.contentWrapper) {
                height = this.contentWrapper.clientHeight;
            } else {
                height = this.$activeSlide.querySelector('.preparation-list__content').clientHeight;
            }

            $swiperNavigation.style.setProperty('--translateY', `translateY(${height + 74}px)`);
        }
    }

    addPaginationLabel () {
        this.$preparationSliderPagination = this.$preparation.querySelector('[' + this.settings.initAttr + '="root"] .swiper-pagination');

        if (this.$preparationSliderPagination) {
            const label = document.createElement('span');
            label.textContent = this.preparationSliderStepLabel;
            label.classList.add('swiper-step-label');
            this.$preparationSliderPagination.parentNode.insertBefore(label, this.$preparationSliderPagination);
        }
    }

    updateSlideOpacity () {
        for (let index = 0; index < this.$$preparationSlides.length; index++) {
            const $image = this.$$preparationSlides[index].querySelector('img');
            if ($image) {
                if (index > this.activeSlideIndex + 1 || index < this.activeSlideIndex - 1) {
                    $image.style.setProperty('--opacity', '0');
                } else if (index === this.activeSlideIndex) {
                    $image.style.setProperty('--opacity', '1');
                } else {
                    $image.style.setProperty('--opacity', '0.3');
                }
            }
        }
    }

    initSlider () {
        this.$preparationSlider = new this.Slider(this.$preparationSliderWrapper, {
            modules: [A11y, EffectCoverflow, Navigation, Pagination, Scrollbar],
            autoHeight: true,
            speed: 500,
            grabCursor: true,
            slidesPerView: 'auto',
            effect: 'coverflow',
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 0,
                modifier: 0,
                slideShadows: false
            },
            centeredSlides: true,
            fractionText: '•',
            prevnext: true,
            scrollbar: true,
            scrollbarAppendToControls: true,
            counter: true,
            counterCustom: true,
            initAttr: this.settings.initAttr,
            breakpoints: {
                1024: {
                    coverflowEffect: {
                        rotate: 0,
                        stretch: '85%',
                        depth: 250,
                        modifier: 1,
                        slideShadows: false
                    }
                }
            },
            onInit: ($current, currentIndex, activeIndex) => {
                this.activeSlideIndex = activeIndex;
                this.$activeSlide = currentIndex;
                this.orderSwiperButtons();
                this.addPaginationLabel();
                setTimeout(() => {
                    this.addButtonLabel();
                    this.updateSlideOpacity();
                }, 50);
            },
            onSlideChange: (slider, $current, currentIndex, activeIndex) => {
                this.activeSlideIndex = activeIndex;
                this.$activeSlide = currentIndex;
                this.orderSwiperButtons();
                this.updateSlideOpacity();
                if (this.hasSliderImages) {
                    this.positionSliderContent();
                }
            }
        });

        this.sliderActive = true;
    }

    updateVideoControls () {
        if (this.videoPlaying) {
            this.$preparationSlidePlay.classList.add('is--hidden');
            this.$preparationSlidePause.classList.remove('is--hidden');
        } else {
            this.$preparationSlidePlay.classList.remove('is--hidden');
            this.$preparationSlidePause.classList.add('is--hidden');
        }
    }

    setEvents () {
        if (this.$preparationSlideVideo) {
            this.$preparationSlidePlay.addEventListener('click', (e) => {
                this.videoPlaying = true;
                this.updateVideoControls();
                this.$preparationSlideVideo.play();
                e.preventDefault();
            });

            this.$preparationSlidePause.addEventListener('click', (e) => {
                this.videoPlaying = false;
                this.updateVideoControls();
                this.$preparationSlideVideo.pause();
                e.preventDefault();
            });

            this.$preparationSlideVideo.addEventListener('pause', () => {
                this.videoPlaying = false;
                this.updateVideoControls();
            });
        }
    }
}

export { PreparationList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-preparationlist="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new PreparationList($root);
            $rootAPI.initialize();
        });
    }
});
